export const getMacroProgress = (planned, target) => {
  if (!target || target <= 0) {
    return 0;
  }
  return Math.min((planned / target) * 100, 100);
};


export const getMacroStatus = (planned, target) => {
  if (!target || target <= 0) {
    return { tone: "stone", label: "Geen doel" };
  }

  const ratio = planned / target;
  if (ratio <= 1.05 && ratio >= 0.8) {
    return { tone: "emerald", label: "Op koers" };
  }
  if (ratio <= 1.2 && ratio >= 0.6) {
    return { tone: "amber", label: "Bijsturen" };
  }
  return { tone: "rose", label: ratio > 1.2 ? "Boven doel" : "Ruimte over" };
};


export const getCombinedMacroStatus = ({ kcalPlanned, kcalTarget, carbsPlanned, carbsTarget }) => {
  const kcalStatus = getMacroStatus(kcalPlanned, kcalTarget);
  const carbsStatus = getMacroStatus(carbsPlanned, carbsTarget);

  if (kcalStatus.tone === "rose" || carbsStatus.tone === "rose") {
    return { tone: "rose", label: "Boven target" };
  }
  if (kcalStatus.tone === "amber" || carbsStatus.tone === "amber") {
    return { tone: "amber", label: "Bijna in balans" };
  }
  if (kcalStatus.tone === "emerald" && carbsStatus.tone === "emerald") {
    return { tone: "emerald", label: "Sterke fit" };
  }
  return { tone: "stone", label: "Check targets" };
};


const normalizeOptionalNumber = (value) => {
  if (value === "" || value === undefined || value === null) {
    return null;
  }
  return Number(value);
};


export const findActiveMacroPreset = (presets, currentValues) => {
  if (!presets?.length || !currentValues) {
    return null;
  }

  return presets.find((preset) => (
    Number(preset.calorie_target_daily) === Number(currentValues.calorie_target_daily)
    && Number(preset.daily_carb_target) === Number(currentValues.daily_carb_target)
    && normalizeOptionalNumber(preset.max_carbs_per_meal) === normalizeOptionalNumber(currentValues.max_carbs_per_meal)
    && preset.carb_priority_mode === currentValues.carb_priority_mode
  )) || null;
};